import { environment } from '../../environments/environment';

const API_BASE_ENDPOINT: string = new environment().getServerUrl();
const Url_Portal: string = new environment().getUrlPortal();

export const Constants = Object.freeze({
    Routes: {
        Home: '/Home',
        Error: '/Error'
    },
    EndPoints: {
        User: {
            
            GetUserName: API_BASE_ENDPOINT + 'User/GetUserName',
            GetCoordCard: API_BASE_ENDPOINT + 'User/GetCoordCard',
            PostValidateCoordCard: API_BASE_ENDPOINT + 'User/ValidateCoordCard',
            PostValidateEmailUser: API_BASE_ENDPOINT + 'User/ValidateExistEmailUser',
            PostValidateEnterpriseNm: API_BASE_ENDPOINT + 'User/ValidateEnterpriseNm',
            PostSendEmailUserExist: API_BASE_ENDPOINT + 'User/SendEmailUserExist',
            PostGeneratePotentialUserComplete: API_BASE_ENDPOINT + 'User/GeneratePotentialUserComplete',
            GetPotentialUser: API_BASE_ENDPOINT + 'User/GetPotentialUser',
            GetUserCriteria: API_BASE_ENDPOINT + 'User/GetUserCriteria',
            ActivateUser: API_BASE_ENDPOINT + 'User/ActivateUser',
            ReactivateUser: API_BASE_ENDPOINT + 'User/ReactivateUser',
            ValidateReactivationUrl: API_BASE_ENDPOINT + 'User/ValidateReactivationUrl',
            PostPrevioReactivacion: API_BASE_ENDPOINT + 'User/PrevioReactivacion',
            ValidatePassword: API_BASE_ENDPOINT + 'User/ValidatePassword',
            PostDespertarAPIs: API_BASE_ENDPOINT + 'User/DespertarAPIs'
        },
        Maestras: 
        {
        },

    },
    UserRoles: {
        
    },
    Token_Auth_Token: '',
    Expiration_Token_Days: 1,
    Token_Remember_Auth_Token: '',
    Expiration_Token_Remember_Days: 30,
    Access_Control_Origin: '*',
    Url_Portal
});
